import React from 'react';
import { useI18n } from '../contexts/I18n';
import './DateIcon.css';

const DateIcon = () => {
  const { lang } = useI18n();
  const now = new Date();
  const day = now.getDate();
  
  // Use Arabic locale for Arabic, English for English
  const locale = 'en-US';
  const month = now.toLocaleDateString(locale, { month: 'short' });
  const year = now.getFullYear();

  return (
    <div className="date-icon" dir={lang === 'ar' ? 'rtl' : 'ltr'}>
      <div className="date-icon-header">
        <span className="month">{month}</span>
        <span className="year">{year}</span>
      </div>
      <div className="date-icon-body">
        <span className="day">{day}</span>
      </div>
    </div>
  );
};

export default DateIcon;
